<template>
  <div>
    <v-card outlined>
      <v-card-text class="dialog-checkout-in overflow-y-auto " style="background-color: #FCFCFC;">
        <!-- loading overlay -->
        <v-overlay v-if="isPageLoading" color="white" absolute opacity="1">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </v-overlay>
        <div v-if="!view">
          <h3 class="text-bold">{{ $t('area.checkout_and_decrease_stall') }}</h3>
        </div>
        <div v-if="getContract && (getContract.isRenewEffective || getContract.isSuspend)" class="checkkout-warning">
          <div>{{ $t('warning') }} :</div>
          <v-tooltip top v-if="getContract.isRenewEffective">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-chip color="warning" large tonal>{{ $t('contract.contract_is_waiting_for_renewal') }}</v-chip>
              </div>
            </template>
            <div class="text-center">
              <div> <b>{{ $t('contract.contract_is_waiting_for_renewal_in_date', { id: getContract.contractId, renewDate: getContract.renewEffectiveDateFormat }) }}</b></div>
              <div>
                {{ $t('validate.warning_checkout_and_decrease_stall') }}
              </div>
            </div>
          </v-tooltip>
          <v-tooltip top v-if="getContract.isSuspend">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-chip color="warning" large tonal>{{ $t('contract.contract_is_in_pause_stall') }}</v-chip>
              </div>
            </template>
            <div class="text-center">
              <div><b> {{ $t('contract.contract_is_in_pause_stall_with_id', { id: getContract.contractId }) }}</b></div>
              <div>
                {{ $t('validate.warning_should_wait_for_pause_stall_to_finish_before_checkout') }}
              </div>
            </div>
          </v-tooltip>
        </div>
        <template v-if="getContract.isActive">
          <div v-if="first || firstStep">
            <AlertCard class="my-3" color="warning">
              <template v-slot:title>
                <div>STEP 1 : {{ $t('customer.select_transaction_type') }}</div>
              </template>
              <template v-slot:content>
                <div class="pt-8 pb-4 px-5">
                  <v-select 
                    :items="contractAreas.length > 1
                      ? [
                          {
                            label: $t('contract.close_contract'),
                            value: 'checkout',
                          },
                          {
                            label: $t('contract.reduce_area'),
                            value: 'reduce',
                          },
                          {
                            label: $t('contract.escaped'),
                            value: 'escaped',
                          },
                        ]
                      : [
                          {
                            label: $t('contract.close_contract'),
                            value: 'checkout',
                          },
                          {
                            label: $t('contract.escaped'),
                            value: 'escaped',
                          },
                        ]
                    "
                    v-model="value"
                    item-text="label"
                    item-value="value"
                    outlined
                    dense
                    hide-details
                    :no-data-text="$t('noinfo')">
                  </v-select>
                  <div v-if="value == 'reduce'">
                    <v-checkbox
                      v-for="(item, index) of contractAreas"
                      hide-details
                      v-model="areaIds"
                      :key="index"
                      :label="item.name"
                      :value="item.objectId">
                    </v-checkbox>
                  </div>
                  <div class="pt-5">
                    <v-btn
                      color="info"
                      elevation="0"
                      class="mr-2"
                      :disabled="(value == 'reduce' && areaIds.length < 1 ? true : false) || getContract.isNotCheckInArea || getContract.isRenewEffective"
                      :loading="isLoading"
                      @click="nextStep"
                    >{{ $t('customer.continue_transaction') }}
                    </v-btn>
                    <v-btn
                      color="error"
                      elevation="0"
                      :disabled="checkouts.length < 1"
                      @click="isNextStep = false;"
                    >{{ $t('cancel') }}
                    </v-btn>
                    <span v-if="getContract.isNotCheckInArea" class="error--text ms-3">{{ $t('validate.cannot_check_out_because_not_in_area') }}</span>
                  </div>
                </div>
              </template>
            </AlertCard>
          </div>
        </template>
        <div>
          <template v-if="next || isNextStep">
            <div class="py-5 mb-3 text-base font-bold text-center rounded-lg text-sunset-orange-500 bg-sunset-orange-50"
              v-if="isAlert">
              {{ $t('contract.because_you_selected_all_stalls_the_transaction_will_change_to_close_contract') }}
              <div class="text-sm">{{ $t('validate.please_check_the_transaction_again') }}</div>
            </div>
            <template v-if="!enableCannotCheckOut || true">
              <AlertCard class="mt-3" color="warning">
                <template v-slot:title>
                  <div>STEP 2 : {{ $t('bill.check_bill_not_paid') }}</div>
                </template>
                <template v-slot:content>
                  <div class="pt-5 pb-4 px-5">
                    <InvoiceTable :itemsProps="invoiceCheckout.unpaidInvoicesTable" @onRowClick="onRowClick" />
                    <div :class="`flex justify-center py-3 text-xl rounded ${invoiceCheckout.unpaidTotalCost > 0
                      ? 'text-red-600 bg-red-100'
                      : invoiceCheckout.unpaidTotalCost == 0
                        ? 'text-gray-400'
                        : 'success--text bg-green-100'
                      }`">{{ $t('payment.remaining_pending') }} {{ invoiceCheckout.unpaidTotalCost | currencySuffixTextThEn }}</div>
                  </div>
                </template>
              </AlertCard>

              <AlertCard class="mt-3" color="warning">
                <template v-slot:title>
                  <div class="d-flex justify-space-between align-center w-100">
                    <div>STEP 3 : {{ $t('bill.check_checkout_bill') }}</div>
                    <v-btn v-if="!view && !isView" color="info" elevation="0" class="ml-2" @click="onCreateInvoice">
                      <v-icon>mdi-plus</v-icon>{{ $t('bill.add_checkout_bill') }}
                    </v-btn>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="pt-5 pb-4 px-5">
                    <InvoiceTable :itemsProps="invoiceCheckout.checkOutInvoicesTable" @onRowClick="onRowClick" />
                    <div :class="`flex justify-center py-3 text-xl rounded ${invoiceCheckout.checkOutTotalCost > 0
                      ? 'text-red-600 bg-red-100'
                      : invoiceCheckout.checkOutTotalCost == 0
                        ? 'text-gray-400'
                        : 'success--text bg-green-100'
                      }`">
                      {{ $t('payment.remaining_pending') }} {{ !enableCannotCheckOut ? '' : `(${$t('draft')})` }}
                      {{ invoiceCheckout.checkOutTotalCost | currencySuffixTextThEn }}
                    </div>
                  </div>
                </template>
              </AlertCard>

              <AlertCard class="mt-3" color="warning">
                <template v-slot:title>
                  <div>STEP 4 : {{ $t('bill.check_deposit_bill') }}</div>
                </template>
                <template v-slot:content>
                  <div class="pt-5 pb-4 px-5">
                    <InvoiceTable :itemsProps="invoiceCheckout.depositInvoicesTable" @onRowClick="onRowClick" />
                    <div :class="`flex justify-center py-3 text-xl rounded ${invoiceCheckout.depositTotalCost > 0
                      ? 'success--text bg-green-100'
                      : invoiceCheckout.depositTotalCost == 0
                        ? 'text-gray-400'
                        : 'text-red-600 bg-red-100'
                      }`">
                      {{ $t('payment.deposit_cost') }}
                      {{ invoiceCheckout.depositTotalCost | currencySuffixTextThEn }}
                    </div>
                    <template v-if="value != 'escaped'">
                      <p class="text-sm text-center text-gray-400 mt-8 mb-0">{{ $t('validate.in_the_case_of_reducing_the_stall_only_the_stall_will_be_calculated') }}</p>
                      <div class="flex justify-center mb-4">
                        <v-switch 
                          v-model="isForfeit" 
                          :disabled="invoiceCheckout.depositTotalCost == 0"
                          @change="forfeitPrepare"
                          color="success"
                          :value="false" 
                          hide-details
                        >
                          <template v-slot:label>
                            <span class="text-gray-400">{{ $t('payment.want_to_forfeit_deposit') }}</span>
                          </template>
                        </v-switch>
                      </div>
                    </template>
                  </div>
                </template>
              </AlertCard>

              <AlertCard class="mt-3" color="warning" v-if="isForfeit && value != 'escaped'">
                <template v-slot:title>
                  <div>STEP 5 : {{ $t('payment.check_forfeit_deposit_list') }}</div>
                </template>
                <template v-slot:content>
                  <div class="pt-5 pb-4 px-5">
                    <div>
                      <v-radio-group v-model="modeForfeitSelect" row hide-details class="mt-2" @change="forfeitPrepare">
                        <div class="d-flex justify-space-around w-100 gap-3">
                          <v-radio :label="$t('payment.forfeit_all')" :value="1" class="box-radio"></v-radio>
                          <v-radio :label="$t('payment.enter_amount')" :value="2" class="box-radio"></v-radio>
                          <v-radio :label="$t('payment.select_from_list')" :value="3" class="box-radio"></v-radio>
                        </div>
                      </v-radio-group>
                    </div>
                    <div class="border border-gray-400 rounded px-5 py-3 mt-4">
                      <div v-if="modeForfeitSelect != 3" class="d-flex justify-space-between align-center gap-3">
                        <div>{{ $t('product.quantity') }}</div>
                        <div class="w-100">
                          <v-currency-field
                            v-model="forfeitCost" 
                            class="mt-0 pt-0 input-right" 
                            outlined
                            :min="0"
                            :max="invoiceCheckout.depositTotalCost"
                            :disabled="modeForfeitSelect == 1" 
                            hide-details
                            @input="forfeitPrepare"
                            :rules="[rules.required]"
                            dense
                          />
                        </div>
                        <div>{{ $helper.currencyThEn() }}</div>
                      </div>
                      <div v-else-if="modeForfeitSelect == 3">
                        <div v-for="invoice of invoiceCheckout.depositInvoices" :key="invoice.documentId">
                          <div class="forfeit-invoice-header"> {{ invoice.documentId }}</div>
                          <v-checkbox class="forfeit-item" v-for="(item, index) of invoice.items"
                            v-model="item.isForfeit"
                            color="success"
                            @change="forfeitPrepare" 
                            :key="`${item.name}-${index}`"
                            hide-details
                            :disabled="item.type == 'discount'"
                          >
                            <template v-slot:label>
                              <span class="mx-3">{{ `${item.name} ${item.detail ? '(' + item.detail + ')' : ''}` }}</span>
                              <span class="mx-3">{{ `${item.area ? `${$t('area.title')} ${item.area.name}` : `${$t('area.not_specify_stall')}`}` }}</span>
                              <span class="mx-3">{{ `${$helper.toCurrency(item.totalValue)}` }}</span>
                            </template>
                          </v-checkbox>
                        </div>
                      </div>
                      <v-textarea
                        class="mt-3"
                        :placeholder="$t('validate.please_input_reason_for_forfeiting_deposit')"
                        no-resize
                        :label="$t('payment.reason_for_forfeit')"
                        outlined
                        v-model="forfeitNote"
                        rows="3"
                        :rules="[rules.required]"
                        hide-details
                      />
                      <div :class="`flex justify-center py-3 mt-3 text-xl text-web-orange-600 bg-web-orange-100 rounded`">
                        {{ $t('payment.forfeit_deposit_money_value') }}
                        {{ forfeitCost | currencySuffixTextThEn }}
                      </div>
                    </div>
                  </div>
                </template>
              </AlertCard>
              
              <AlertCard class="mt-3" color="info">
                <template v-slot:title>
                  <div>{{ $t('area.summary_checkout') }}</div>
                </template>
                <template v-slot:content>
                  <div class="pt-7 pb-4 px-5">
                    <div v-if="value == 'escaped'" class="d-flex  gap-3">
                      <BoxCheckoutSummary 
                        color="error" 
                        :totalValue="invoiceCheckout.unpaidTotalCost + invoiceCheckout.checkOutTotalCost" 
                        :title="$t('bill.bad_debt')"
                      />
                      <BoxCheckoutSummary 
                        color="success" 
                        :totalValue="invoiceCheckout.depositTotalCost" 
                        :title="$t('contract.deposit_received')"
                      />
                    </div>
                    <div v-else>
                      <BoxCheckoutSummary 
                        :color="invoiceCheckout.isPaidClass.color" 
                        :totalValue="invoiceCheckout.totalCostAbs" 
                        :title="`${calCulateInvoice.text} ${!enableCannotCheckOut ? '' : `(${$t('area.status_draft')})`}`"
                      />
                    </div>
                  </div>
                </template>
              </AlertCard>
              <div class="py-3 mt-5">
                <v-menu 
                  ref="menu_start_date"
                  v-model="isCheckOutDate"
                  :close-on-content-click="false"
                  :return-value.sync="checkOutDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  :disabled="view || isView"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="$helper.datelabel(checkOutDate)"
                      :label="$t('area.checkout_date')"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      :disabled="view || isView" hide-details>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="checkOutDate"
                    no-title
                    scrollable locale="th"
                    :header-date-format="$helper.headerDateFormat"
                    :year-format="$helper.yearFormat"
                    persistent-hint
                    :weekday-format="$helper.formatWeekday"
                    :month-format="$helper.formatMonth"
                    :disabled="view || isView"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="error"
                      @click="isCheckOutDate = false"
                      :disabled="view || isView"
                    >{{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      text
                      color="success"
                      :disabled="view || isView"
                      @click="$refs.menu_start_date.save(checkOutDate);"
                    >{{ $t('confirm') }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <div class="py-3">
                <span>{{ $t('project.image_or_file_if_have') }}</span>
                <ImageUpload v-model="imageFiles" :isLoading="isLoading" :isView="isView || view" refName="fileupload" />
              </div>
              <div class="py-3">
                <span>{{ $t('note') }}</span>
                <v-text-field
                  :label="$t('note')"
                  textarea
                  solo
                  flat
                  hide-details
                  v-model="invoiceCheckout.note"
                  background-color="grey lighten-4"
                  :disabled="view || isView">
                </v-text-field>
              </div>
              <div class="py-3" v-if="invoiceCheckout.totalCost > 0">
                <span>{{ $t('payment.select_bank_account_to_refund_deposit') }}</span>
                <v-select
                  :no-data-text="$t('customer.no_bank_account_data')"
                  :items="customerBanking"
                  v-model="invoiceCheckout.refundBankAccount"
                  hide-details
                  dense
                  :item-text="(i) =>
                    `${$t('account.bank_account_message', { bankcode: getBank(i.bankCode), accountNumber: i.accountNumber, accountName: i.accountName })}`
                    " :item-value="(i) => i" return-object :label="$t('payment.bank_account')" solo flat :disabled="view || isView"
                  background-color="grey lighten-4">
                </v-select>
              </div>
              <div class="text-right" v-if="false">
                <v-btn
                  color="error"
                  class="mr-2"
                  elevation="0"
                  @click="onDismissCheckout"
                  v-if="!view"
                  :disabled="isLoading"
                >{{ $t('cancel') }}
                </v-btn>
                <v-btn
                  color="success"
                  elevation="0"
                  @click="onPreConfirm"
                  :loading="isLoading"
                  :disabled="isLoading"
                  v-if="!isView && !view"
                >{{ $t('validate.confirm_checkout') }}
                </v-btn>
                <v-btn
                  color="success"
                  elevation="0"
                  @click="isCheckoutPayment = true"
                  :loading="isLoading"
                  :disabled="isLoading"
                  v-if="isView"
                >
                  <v-icon left>mdi-cash</v-icon>{{ $t('customer.continue_transaction') }}
                </v-btn>
              </div>
            </template>
            <template v-else>
              <div class="mt-3">
                <v-menu
                  ref="menu_check_out_date"
                  v-model="isCheckOutDate"
                  :close-on-content-click="false"
                  :return-value.sync="checkOutDate"
                  transition="scale-transition"
                  offset-y min-width="auto"
                  :disabled="view || isView">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="$helper.datelabel(checkOutDate)"
                      :label="$t('area.checkout_date')"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      :disabled="view || isView">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="checkOutDate"
                    no-title
                    scrollable
                    locale="th"
                    :header-date-format="$helper.headerDateFormat"
                    :year-format="$helper.yearFormat"
                    persistent-hint
                    :weekday-format="$helper.formatWeekday"
                    :month-format="$helper.formatMonth"
                    :disabled="view || isView"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="error"
                      @click="isCheckOutDate = false"
                      :disabled="view || isView"
                    >{{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      text
                      color="success"
                      :disabled="view || isView"
                      @click="$refs.menu_check_out_date.save(checkOutDate);"
                    >{{ $t('confirm') }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <div>
                <v-text-field
                  :label="$t('note')"
                  textarea
                  outlined
                  flat
                  v-model="invoiceCheckout.note"
                  :disabled="view || isView">
                </v-text-field>
              </div>
              <div class="text-right">
                <v-btn
                  color="error"
                  class="mr-2"
                  elevation="0"
                  @click="onDismissCheckout"
                  v-if="!view"
                >{{ $t('cancel') }}
                </v-btn>
                <v-btn
                  color="info"
                  elevation="0"
                  @click="sendApproveTask"
                  :loading="isLoading"
                  v-if="!isView && !view"
                >{{ $t('appeal.send_appeal') }}
                </v-btn>
              </div>
            </template>
          </template>
        </div>
        <div v-if="checkouts.length > 0 && !isNextStep">
          <h4 class="py-3">{{ $t('history') }}</h4>
          <div
            :class="`flex items-center justify-between p-3 mb-2 transition-all border rounded-lg cursor-pointer  ${checkout.isPaidClass ? checkout.isPaidClass.css : ''}`"
            v-for="(checkout, i) in checkouts" :key="checkout.objectId" @click="getContractCheckoutFn(checkout)">
            <div>
              {{ $t('area.checkout_history_index', { index: i + 1 }) }}
              <div :class="`font-bold`">{{ momentDate(checkout.date) }}</div>
            </div>
            <div class="text-sm text-right">
              <div>{{ checkout.isPaidClass.text }}</div>
              <span :class="`text-base font-bold`">{{ checkout.totalCostAbs | currencySuffixTextThEn(checkout.currencyCode) }}</span>
            </div>
          </div>
          <div class="py-5 text-center" v-if="!firstStep">
            <div class="py-3">
              {{ $t('validate.you_have_checkout_process') }}
              <br />{{ $t('validate.please_finish_the_process_before_doing_other_process') }}
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="next || isNextStep">
        <div v-if="!isSentBillCheckout && !enableCannotCheckOut" class="align-center">
          STEP 3 :
          <span class="text-red-500">{{ $t('bill.checkout_bill_not_send') }}</span>
        </div>
        <div v-if="isForfeit && value != 'escaped' && (!forfeitNote || !forfeitCost)">
          STEP 5 :
          <span class="text-red-500">{{ $t('validate.must_input_reason_for_forfeit') }}</span>
        </div>
        <v-spacer></v-spacer>
        <template v-if="!enableCannotCheckOut">
          <v-btn
            color="error"
            class="mr-2"
            elevation="0"
            @click="onDismissCheckout"
            v-if="!view">{{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            @click="onPreConfirm"
            :loading="isLoading"
            :disabled="!isSentBillCheckout || (isForfeit && value != 'escaped' && (!forfeitNote || !forfeitCost))"
            v-if="!isView && !view"
          >{{ $t('validate.confirm_checkout') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            @click="isCheckoutPayment = true"
            :loading="isLoading"
            v-if="isView"
          >
            <v-icon left>mdi-cash</v-icon>{{ $t('customer.continue_transaction') }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            color="error"
            class="mr-2"
            elevation="0"
            @click="onDismissCheckout"
            v-if="!view"
          >{{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="info"
            elevation="0"
            @click="createDraftCheckout"
            :loading="isLoading"
            :disabled="isForfeit && value != 'escaped' && (!forfeitNote || !forfeitCost)"
            v-if="!isView && !view"
          >{{ $t('area.create_draft_checkout') }}
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
    <InvoiceDialogComponent
      :projectId="getProjectId"
      :documentType="4"
      :contractData="getContract"
      v-model="isInvoiceDialog"
      :invoiceId="invoiceId"
      :canSend="!enableCannotCheckOut"
      @onSaveSuccess="nextStep"
      @onSendSuccess="nextStep"
      @onUnSendSuccess="nextStep"
    />
    <CheckoutPayment
      v-if="isCheckoutPayment"
      v-model="isCheckoutPayment"
      :isCreate="true"
      @viewDetail="onViewDetail"
      @onSuccess="eventClose"
      @onSuccessCheckout="eventCloseContract"
      @onCancelPaymentApprove="init()" 
    />
    <ConfirmDialogComponent
      v-model="isConfirmDialog"
      :title="$t('payment.confirm_transaction')"
      :text="$t('validate.cannot_edit_data_after_confirm')"
      textClass="text-red-500" @onOk="onSaveCheckout"
      :textBtnOk="value == 'reduce' ? $t('contract.confirm_reduce_area') : $t('confirm_transaction')"
      :textBtnCancel="$t('cancel')"
      :isConfirmCheck="true"
      type="warning"
      :delay="5"
    />
    <CheckoutDialog
      v-model="isContractCheckOutDialog"
      :contractCheckOutId="contractCheckOutId"
      @onSaveSuccess="onContractCheckOutSaveSuccess"
      :method="(tempContractCheckOut && tempContractCheckOut.isSendApproveTask
                && (tempContractCheckOut.approveStatus == 'pending'
                || tempContractCheckOut.approveStatus == 'rejected')) 
                ? 'view' : 'edit'"
      :isClearDebt="true" 
    />
    <!-- loading dialog -->
    <v-dialog v-model="isCheckoutLoading" persistent max-width="500px">
      <v-card height="250">
        <!-- v-overlay -->
        <v-overlay color="white" :absolute="true">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { Banking, ContractCheckout } from "../classes";
import InvoiceTable from "./InvoiceTable.vue";
import InvoiceDialogComponent from "./InvoiceDialog.component.vue";
import CheckoutPayment from "./CheckoutPayment.vue";
import ConfirmDialogComponent from "./ConfirmDialog.component.vue";
import CheckoutDialog from "./CheckoutDialog.vue";
import CheckoutDetail from "./CheckoutDetail.vue";
import ImageUpload from "./ImageUpload.vue";
import AlertCard from "./AlertCard.component.vue";
import BoxCheckoutSummary from "./BoxCheckoutSummary.component.vue";
export default {
  components: {
    InvoiceTable,
    InvoiceDialogComponent,
    CheckoutPayment,
    ConfirmDialogComponent,
    CheckoutDialog,
    CheckoutDetail,
    ImageUpload,
    AlertCard,
    BoxCheckoutSummary
  },
  computed: {
    ...mapGetters({
      contractAreas: "contract/getAreas",
      contractId: "contract/getContractId",
      invoiceCheckout: "contractCheckout/contractCheckout",
      getProjectId: "markets/getProjectId",
      getContract: "contract/getContract",
      getContractId: "contract/getContractId",
      customerBanking: "customer/getCustomerBanking",
      customer: "customer/getCustomer",
      checkouts: "contractCheckout/checkouts",
      adminGetByMarketId: "admin/getByMarketId",
      employeeGetByMarketId: "employee/getByMarketId",
    }),
    calCulateInvoice() {
      let depositTotalCost = this.invoiceCheckout.depositTotalCost - (this.isForfeit ? parseFloat(this.forfeitCost) : 0)
      const total = depositTotalCost - (this.invoiceCheckout.unpaidTotalCost + this.invoiceCheckout.checkOutTotalCost);
      return {
        total: Math.abs(total),
        text: total > 0 ? this.$t('payment.refund_customer_money') : total < 0 ? this.$t('payment.collect_customer_money') : this.$t('payment.no_expense'),
        class:
          total > 0
            ? "text-green-600"
            : total == 0
              ? "text-picton-blue-500"
              : "text-web-orange-600"
      };
    },
    isSentBillCheckout() {
      let res = true;
      for (const checkOutInvoice of this.invoiceCheckout.checkOutInvoices) {
        if (!checkOutInvoice.isSent && !checkOutInvoice.isCancelled) {
          res = false;
          break;
        }
      }
      return res;
    },
    employee() {
      return this.employeeGetByMarketId(this.marketId);
    },
    enableCannotCheckOut() {
      return this.employee && this.employee.enableCannotCheckOut;
    },
    firstStep() {
      let fs = false;
      if (
        this.checkouts.length &&
        this.checkouts.filter(
          d =>
            d.approveStatus != "rejected" &&
            d.status != "rejected" &&
            (d.approveStatus == "draft" ||
              d.status == "draft" ||
              d.approveStatus == "pending" ||
              d.status == "pending")
        ).length > 0
      ) {
        fs = false;
      } else {
        fs = true;
      }
      return fs;
    }
  },
  watch: {
    check(val) {
      if (val) {
        this.init();
      }
    },
    contractId(val) {
      if (val) {
        this.init();
      }
    },
    isInvoiceDialog(val) {
      this.nextStep();
    },
    value(val) {
      if (val == "checkout") {
        this.isCloseContract = true;
        this.isEscaped = false;
      } else if (val == 'escaped') {
        this.isCloseContract = true;
        this.isEscaped = true;
      } else {
        this.isCloseContract = false;
        this.isEscaped = false;
      }
    }
  },
  mounted() {
    this.init();
  },
  props: {
    isContract: Boolean,
    first: Boolean,
    view: Boolean,
    next: Boolean,
    check: Boolean,
    projectId: String,
    marketId: String
  },
  data() {
    return {
      rules: {
        required: i => !!i || this.$t('validate.please_input')
      },
      value: "checkout",
      form: {
        areaIds: [],
        customerBanking: {},
      },
      isCloseContract: false,
      isEscaped: false,
      isNextStep: false,
      isInvoiceDialog: false,
      isCheckoutPayment: false,
      areaIds: [],
      isLoading: false,
      // firstStep: false,
      isCheckoutLoading: false,
      isAlert: false,
      confirmItem: {},
      isConfirmDialog: false,
      isView: false,
      invoiceId: null,
      isPageLoading: false,
      checkOutDate: this.$moment().format("YYYY-MM-DD"),
      leaveDate: this.$moment().format("YYYY-MM-DD"),
      isCheckOutDate: false,
      isLeaveDatePicker: false,
      contractCheckOutId: null,
      isContractCheckOutDialog: false,
      tempContractCheckOut: null,
      isForfeit: false,
      modeForfeitSelect: 1,
      forfeitCost: 0,
      forfeitNote: '',
      isFirst: true,
      imageFiles: []
    };
  },
  methods: {
    ...mapMutations({
      setContractCheckoutForfeit: 'contractCheckout/setContractCheckoutForfeit'
    }),
    ...mapActions({
      getContractCheckout: 'contractCheckout/getContractCheckout',
      getContractCheckoutsByContract: 'contractCheckout/getContractCheckoutsByContract',
      getContractCheckoutData: 'contractCheckout/getContractCheckoutData',
      createContractCheckout: 'contractCheckout/createContractCheckout',
    }),
    onPreConfirm() {
      this.isConfirmDialog = true;
    },
    onRowClick(e) {
      this.invoiceId = e.objectId;
      this.isInvoiceDialog = true;
    },
    eventCloseContract() {
      this.$emit("onCloseContract");
    },
    eventAfterSaveInvoice(data) {
      this.isInvoiceDialog = false;
      this.invoiceId = data.objectId;
      this.isInvoiceDialog = true;
    },
    async getContractCheckoutFn(item) {
      try {
        this.isCheckoutLoading = true;
        const id = item.objectId;
        this.tempContractCheckOut = item;
        if (item.isNotClearDebt) {
          this.contractCheckOutId = id;
          this.isContractCheckOutDialog = true;
        } else {
          await this.getContractCheckout({ id });
          this.isCheckoutPayment = true;
        }
        this.isCheckoutLoading = false;
      } catch (e) {
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    async onContractCheckOutSaveSuccess(item) {
      await this.loadCheckout();
      try {
        if (item && item.objectId) {
          this.isCheckoutLoading = true;
          await this.getContractCheckout({ id: item.objectId });
          this.isCheckoutPayment = true;
          this.isCheckoutLoading = false;
        }
      } catch (e) {
        this.$toast.show({ content: this.$t('error'), color: "error" });
      }
    },
    async eventClose() {
      if (this.isCloseContract) {
        this.init();
      } else {
        this.$emit("onReduce");
        this.init();
      }
    },
    async init() {
      if (this.contractId && this.contractId != "") {
        this.form = this.invoiceCheckout;
        this.value = "checkout";
        this.areaIds = [];
        // this.firstStep = false;
        this.isNextStep = false;
        this.checkOutDate = this.$moment().format("YYYY-MM-DD");
        this.leaveDate = this.$moment().format("YYYY-MM-DD");
        await this.loadCheckout();
        this.isNextStep = false;
      }
    },
    async loadCheckout() {
      try {
        this.isPageLoading = true;
        await this.getContractCheckoutsByContract({ contractId: this.contractId });
        this.isPageLoading = false;
      } catch (e) {
        this.isPageLoading = false;
        console.log(e);
      }
    },
    momentDate(date) {
      return this.$moment(date).format("DD MMMM YYYY");
    },
    getBank(code) {
      return Banking.getBank(code)?.name;
    },
    onCreateInvoice() {
      this.invoiceId = null;
      this.isInvoiceDialog = true;
    },
    async nextStep() {
      try {
        this.isView = false;
        this.isAlert = false;
        this.isForfeit = false;
        this.forfeitNote = ''
        this.isLoading = true;
        const areaIds =
          this.value == "reduce"
            ? this.areaIds
            : this.contractAreas ? this.contractAreas.map(item => item.objectId) : [];
        this.areaIds = areaIds;
        const isCloseContract = this.value == "reduce" ? false : true;
        this.isCloseContract = isCloseContract;
        if (
          this.areaIds.length == this.contractAreas.length &&
          this.value == "reduce"
        ) {
          this.value = "checkout";
          this.isCloseContract = true;
          this.isAlert = true;
        }
        await this.getContractCheckoutData({
          contractId: this.contractId,
          isCloseContract: this.isCloseContract,
          areaIds: areaIds
        });
        if (this.isEscaped) {
          this.isForfeit = true;
          this.modeForfeitSelect = 1;
        }
        this.forfeitPrepare()
        this.isNextStep = true;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    forfeitPrepare() {
      if (this.invoiceCheckout?.depositInvoices?.length) {
        if (this.modeForfeitSelect == 1) {
          this.forfeitCost = this.invoiceCheckout.depositTotalCost || 0
        } else if (this.modeForfeitSelect == 2) {
          if (this.isFirst)
            this.forfeitCost = this.invoiceCheckout.depositTotalCost || 0
        } else if (this.modeForfeitSelect == 3) {
          this.forfeitCost = 0
          for (const invoice of this.invoiceCheckout.depositInvoices) {
            for (const item of invoice.items) {
              if (item.isForfeit) {
                this.forfeitCost += item.totalValue
              }
            }
          }
        }
      }
      this.isFirst = false
      this.setContractCheckoutForfeit({
        forfeitCost: this.isForfeit ? this.forfeitCost : 0,
        modeForfeitSelect: this.modeForfeitSelect,
        isForfeit: this.isForfeit,
        depositInvoices: this.invoiceCheckout.depositInvoices
      })
    },
    prepareInvoices(invoices) {
      return invoices.map(i => {
        return {
          ...i,
          invoice: {
            __type: "Pointer",
            className: "Invoice",
            objectId: i.invoice.objectId
          }
        }
      })
    },
    prepareData() {
      return {
        contractId: this.contractId,
        date: this.$moment()
          .endOf("day")
          .toISOString(),
        isCloseContract: this.isCloseContract,
        isEscaped: this.isEscaped,
        areaIds: this.areaIds,
        unpaidTotalCost: this.invoiceCheckout.unpaidTotalCost,
        checkOutTotalCost: this.invoiceCheckout.checkOutTotalCost,
        depositTotalCost: this.invoiceCheckout.depositTotalCost,
        forfeitCost: this.invoiceCheckout.isForfeit ? this.invoiceCheckout.forfeitCost : 0,
        modeForfeitSelect: this.invoiceCheckout.modeForfeitSelect,
        isForfeit: this.invoiceCheckout.isForfeit,
        forfeitNote: this.forfeitNote,
        checkOutInvoices: this.prepareInvoices(this.invoiceCheckout.checkOutInvoices.filter(i => !i.isPaid)),
        depositInvoices: this.prepareInvoices(this.invoiceCheckout.depositInvoices.filter(i => i.isSent && i.isPaid)),
        unpaidInvoices: this.prepareInvoices(this.invoiceCheckout.unpaidInvoices.filter(i => i.isSent && !i.isPaid)),
        refundCost: this.invoiceCheckout.refundCost,
        extraCost: this.invoiceCheckout.extraCost,
        checkOutDate: this.$moment(this.checkOutDate, "YYYY-MM-DD")
          .endOf("day")
          .toISOString(),
        note: this.invoiceCheckout.note,
        refundBankAccount: this.invoiceCheckout.refundBankAccount,
        imageFiles: this.imageFiles,
        currencyRate: this.invoiceCheckout.currencyRate,
        currencyCode: this.$globalCurrencyCode
      };
    },
    onViewDetail() {
      this.isView = true;
      this.isNextStep = true;
    },
    async onSaveCheckout() {
      try {
        this.isLoading = true;
        const params = this.prepareData();
        let checkout = await this.createContractCheckout(params);
        this.$emit("onCreateSuccess", checkout);
        await this.init();
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async sendApproveTask() {
      try {
        this.isLoading = true;
        const params = this.prepareData();
        params.isSendApproveTask = true;
        let checkout = await this.createContractCheckout(params);
        this.$emit("onCreateSuccess", checkout);
        await this.init();
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async createDraftCheckout() {
      try {
        this.isLoading = true;
        let params = this.prepareData();
        params.isDraft = true;
        let checkout = await this.createContractCheckout(params);
        this.$emit("onCreateSuccess", checkout);
        await this.init();
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    onCheckoutPayment() {
      this.isCheckoutPayment = true;
    },
    onDismissCheckout() {
      this.$emit("onClose");
      this.isNextStep = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    margin: 0 5px;
    font-size: 18px;
  }
}

.dialog-checkout-in.v-card__text::v-deep {
  height: 90vh;
  max-height: calc(90vh - 65px - 103px);
}

.forfeit-invoice-header {
  font-weight: bold;
  margin-bottom: 5px;
  color: black;
  font-size: 18px;
  margin-top: 10px;
}

.forfeit-item {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  padding: 10px;
  margin-top: 5px;
}

.forfeit-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0px;

  .forfeit-box-in {
    .forfeit-invoice {
      .forfeit-invoice-header {
        font-weight: bold;
        margin-bottom: 5px;
        margin-top: 10px;
      }

      .forfeit-item {
        margin: 0;
        padding: 0;
        padding-left: 15px;
      }
    }
  }
}

.checkkout-warning {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 10px 15px;
  padding: 15px;
  border: 1px solid var(--v-warning-base);
  border-radius: 15px;

  div {
    font-size: 20px;
  }

  .v-chip {
    margin: 0 5px;
  }
}

.box-radio {
  padding: 15px 10px;
  border: 1px solid #A9A9A9;
  border-radius: 8px;
  width: 100%;
  margin: 0px !important;

  &.v-item--active {
    border: 1px solid var(--v-fontPrimary-base);
  }

  &.v-radio--is-disabled {
    border: 1px solid #A9A9A9;
    opacity: 0.5;
  }
}
</style>